import React, { useMemo, useState, useRef, useCallback, useEffect } from 'react';
import { Layer, Stage, Image, Group, Rect } from 'react-konva';
import { Loader, Tooltip } from '@mantine/core';
// todos
import { SubWindow } from '@starflow/app/components/common/Window';
import { getTempState, useTempState, setTempState } from '@starflow/app/store';
import {
  SelectionItem,
  RectShape,
  useSegmentEditorState,
  SegmentEditor,
  defaultValue as editorDefaultValue,
} from '@starflow/app/components/common/SegmentEditor';
import { translate } from '@shakkerai/util-i18n';

const editorWidth = 520;
const editorHeight = 372;

const currentEditorDefaultValue = {
  ...editorDefaultValue,
  tool: 'mainSelect',
};

const config = {
  noSegment: true,
  showToolbar: true,
  noFeathering: true,
  noInvert: true,
};

const MaskEditorInner = React.memo((props) => {
  const { data } = props;
  const sourceImageUrl = data.sourceImage?.url;

  const [element, setElement] = useState(null);
  const [segmenting, setSegmenting] = useState(false);
  const [shapeType, setShapeType] = useState('segment');
  const [brushSize, setBrushSize] = useState(60);
  const [eraserSize, setEraserSize] = useState(60);

  const [editorState, setEditorState, getEditorState] = useSegmentEditorState(currentEditorDefaultValue);

  useEffect(() => {
    if (!sourceImageUrl) return;

    const image = new globalThis.Image();
    image.src = sourceImageUrl;
    image.crossOrigin = 'anonymous';

    // segmentWorkflowImage(sourceImageUrl).finally(() => {
    //   setSegmenting(false);
    // });

    image.onload = () => {
      // width 和 height是图片的原始尺寸
      const { width, height } = image;

      // 以contain形式展示图片
      const scale = Math.min(editorWidth / width, editorHeight / height);
      // realWidth和realHeight 是图片在canvas上的尺寸
      const realWidth = width * scale;
      const realHeight = height * scale;
      // 图片在canvas上尺寸与原始尺寸的壁纸
      const scaleX = realWidth / width;
      const scaleY = realHeight / height;
      const x = (editorWidth - realWidth) / 2;
      const y = (editorHeight - realHeight) / 2;

      setElement({
        x,
        y,
        scaleX,
        scaleY,
        width,
        height,
        image,
        url: sourceImageUrl,
      });
    };
  }, [sourceImageUrl]);

  useEffect(() => {
    // console.log('xxx editorState.value.shapes',editorState.value.selections)
    if (editorState.value.selections) {
      getTempState('workflowMaskUpdateCallback')?.(editorState.value.selections);
      if (editorState.value.selections.length > 0) {
        setTempState({
          shapesCache: editorState.value.selections,
        });
      }
    }
  }, [editorState.value.selections]);

  if (!element) {
    return (
      <div className="flex flex-col flex-1">
        <div className="flex flex-col items-center justify-center flex-1 bg-[#f4f6f8]">
          <Loader size={16} />
          <div className="mt-3 text-xs text-[#2d2d2d]">正在加载蒙版编辑器</div>
        </div>
        <div className="flex items-center justify-center h-14 px-3 text-caption-500 text-xs">
          <div className="flex items-center justify-center w-5 h-5 mr-[14px] bg-[#f4f6f8] rounded-sm" />
          <div className="flex items-center justify-center w-5 h-5 mr-[14px] bg-[#f4f6f8] rounded-sm" />
          <div className="flex items-center justify-center w-5 h-5 mr-[14px] bg-[#f4f6f8] rounded-sm" />
          <div className="flex items-center justify-center w-5 h-5 mr-[14px] bg-[#f4f6f8] rounded-sm" />
          <div className="flex items-center justify-center w-5 h-5 bg-[#f4f6f8] rounded-sm" />
          <div className="h-5 mx-3 border-l border-[#f4f5f7]" />
          <div className="flex items-center justify-center w-5 h-5 bg-[#f4f6f8] rounded-sm" />
          <div className="flex items-center justify-center w-5 h-5 ml-3 bg-[#f4f6f8] rounded-sm" />
          <div className="flex items-center justify-center w-5 h-5 ml-3 bg-[#f4f6f8] rounded-sm" />
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="relative flex-1 bg-[#f4f6f8]">
        <Stage width={editorWidth} height={editorHeight} draggable={false}>
          <Layer>
            <Image listening={false} fill="#b3dbd830" {...element} />
          </Layer>
        </Stage>
        <div className={`absolute top-0 right-0 w-[${editorWidth}px] h-[${editorHeight}px]`}>
          <SegmentEditor
            config={config}
            element={element}
            editorState={editorState}
            setEditorState={setEditorState}
            getEditorState={getEditorState}
            isShapeCache={true}
            className={''}
            stageClassName={'flex items-center justify-center'}
            inputCanvasScale={Math.min(editorWidth / element.width, editorHeight / element.height)}
          />
        </div>

        {segmenting && shapeType === 'segment' && (
          <div className="absolute inset-0 flex items-center justify-center bg-black/70">
            <span className="text-xs text-white">{translate('workflow_image_segmenting')}</span>
          </div>
        )}
      </div>
    </>
  );
});

export const MaskEditor = React.memo(() => {
  const setWindowPosition = useCallback(() => {
    const workflowPanel = document.getElementById('right-panels-wrapper');
    return { x: workflowPanel.getBoundingClientRect().x - 530, y: 58 };
  }, []);

  const editorData = useTempState('workflowMaskEditorData');

  if (!editorData?.sourceImage) return null;

  return (
    <SubWindow title="绘制蒙版" name="mask-editor" className="w-[520px] h-[472px]" positionSetter={setWindowPosition}>
      <MaskEditorInner data={editorData} />
    </SubWindow>
  );
});
